import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, ViewChild, ElementRef, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  AuthenticationService,
  IdleSessionHeartbeatService,
  SpinnerService,
} from './shared/services';
import { CommonMethods } from './shared/helpers';
import { LandingComponent } from './views/landing/landing.component';
import { Tourservice } from './shared/services/tourservice';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'BI_Reports';
  currentUser!: any;
  private _subscription: Subscription = new Subscription();
  readonly idleHeartbeat = inject(IdleSessionHeartbeatService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public _authenticationService: AuthenticationService,
    private _spinnerService: SpinnerService,
    public _commonMethods: CommonMethods,
    
  ) {
  }

  ngOnInit(): void {
    //this._spinnerService.show();
    this._subscription.add(this._authenticationService.currentUser.subscribe((loggedUser:any) => this.currentUser = loggedUser));
    if (isPlatformBrowser(this.platformId)) {
      this._subscription.add(
        this._authenticationService.authTokenReady$.subscribe((ready) => {
          if (ready) {
            this.idleHeartbeat.start();
          } else {
            this.idleHeartbeat.stop();
          }
        }),
      );
      this._authenticationService.restoreAuthFromStorage();
    }
  }

  ngOnDestroy(): void {
    this.idleHeartbeat.stop();
    this._subscription.unsubscribe();
  }

  onIdleContinue(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.idleHeartbeat.resumeSession();
  }
   
   
  

    showBottomRight() {
      this._commonMethods.clearToast();
      //this._commonMethods.showToastMessage('Message Content','Success Message','error');
    }


    @ViewChild('scrollableDiv') scrollableDiv!: ElementRef<HTMLDivElement>;
    isScrolled = false;
  
    onScroll(): void {
      const scrollTop = this.scrollableDiv.nativeElement.scrollTop;
      this.isScrolled = scrollTop >= 400;
    }


    
 
    @ViewChild('landingComponent') landingComponent!: LandingComponent;
  
    handleScroll(event?: Event) {
      this.landingComponent?.onScroll();
    }
    


     public tour = inject(Tourservice);
   
}
